var SiteContext = function(){};

SiteContext.CONTEXT_P4 = 'web';
SiteContext.CONTEXT_PB = 'web-pb';

SiteContext.isPraha4 = function(){
	return $('html').data('context') === SiteContext.CONTEXT_P4;
};

SiteContext.isPribram = function(){
   return $('html').data('context') === SiteContext.CONTEXT_PB;
};
